<template>
  <div>
    <filter-item v-if="hasUserFilter">
      <form-field-checkbox-group
        label="Users"
        is-sidebar-filter
        :items="activeUsers"
        v-model="users"
        @selectAll="selectAllUsers"
        @deselectAll="deselectAllUsers"
      />
    </filter-item>

    <filter-item>
      <form-field-select
        label="Temperature"
        v-model="temperature"
      >
        <option
          v-for="temp in temperatures"
          :value="temp.value"
          :key="temp.value"
        >{{ temp.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Deal Probability Score"
        v-model="dealProbabilityScore"
      >
        <option
          v-for="score in dealProbabilityScores"
          :value="score.value"
          :key="score.value"
        >{{ score.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Task Required?"
        v-model="required"
      >
        <option
          v-for="option in taskRequiredOptions"
          :value="option.value"
          :key="option.value"
        >{{ option.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Task Tag"
        v-model="tag"
      >
        <option :value="null">All Tags</option>
        <option v-for="option in taskTags"
          :value="option.id"
          :key="option.id"
        >{{ option.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Tasks or Appointments"
        v-model="display"
      >
        <option :value="null">Tasks & Appointments</option>
        <option :value="MODELS.Task.class_name">Tasks Only</option>
        <option :value="MODELS.Appointment.class_name">Appointments Only</option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Default View"
        v-model="pageView"
      >
        <option value="calendar">Calendar</option>
        <option value="list">List</option>
      </form-field-select>
    </filter-item>
  </div>
</template>

<script>
export default {
  name: "UpNextFilter",
  data() {
    return {
      users: [],
      temperature: null,
      dealProbabilityScore: null,
      tag: null,
      required: null,
      display: null,
      pageView: "calendar",
    }
  },
  mounted() {
    this.resetFilters();
  },
  computed: {
    hasUserFilter() {
      return this.$store.getters.authUser.can_access_all_task;
    },
    activeUsers() {
      return this.$store.getters.activeUsers.map(user => {
        return {
          id: user.id,
          label: user.full_name
        }
      })
    },
    temperatures() {
      return [
        { value: null, label: 'All temps' },
        ...this.$store.state.enums.temperatureEnum
      ];
    },
    dealProbabilityScores() {
      return [
        { value: null, label: 'All scores' },
        ...this.$store.state.enums.dealProbabilityScoreEnum
      ];
    },
    taskRequiredOptions() {
      return this.$store.state.upNext.requiredFilterEnum;
    },
    taskTags() {
      return this.$store.getters.taskTags;
    },
  },
  methods: {
    applyFilters() {
      this.$store.commit('upNext/setOneFilter', ['users', this.users])
      this.$store.commit('upNext/setOneFilter', ['temperature', this.temperature])
      this.$store.commit('upNext/setOneFilter', ['dealProbabilityScore', this.dealProbabilityScore])
      this.$store.commit('upNext/setOneFilter', ['tag', this.tag])
      this.$store.commit('upNext/setOneFilter', ['required', this.required])
      this.$store.commit('upNext/setOneFilter', ['display', this.display])
      this.$store.commit('upNext/setOneFilter', ['pageView', this.pageView])

      this.$store.dispatch('updateUserAppFilter');
    },
    resetFilters() {
      const filters = this.$store.getters['upNext/filters'];

      this.users = filters.users;
      this.temperature = filters.temperature;
      this.dealProbabilityScore = filters.dealProbabilityScore;
      this.tag = filters.tag;
      this.required = filters.required;
      this.display = filters.display;
      this.pageView = filters.pageView;
    },
    selectAllUsers() {
      this.users = this.activeUsers.map(user => user.id)
    },
    deselectAllUsers() {
      this.users = []
    },
  }
};
</script>

<style scoped lang="scss">

</style>
